//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TDP.js";
import "../no/TaggedObject.js";
let d=[[],[[["pmiFilterType"],"GetPmiFilterStatus",{R_:{pmiFilterStatus:''}},1,0],[["pmiFilterType","pmiFilterStatus"],"SetPmiFilterStatus",{},2,0]],[]];
SPLM.TDP.TemplateAutomaticTablePMIFilterBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.TDP.TemplateAutomaticTablePMIFilterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.TDP.TemplateAutomaticTablePMIFilterBuilder.Filter = Object.freeze({
    "Dimension" : "Dimension", "AnnotationNote" : "AnnotationNote", "AnnotationFCF" : "AnnotationFCF", "AnnotationDatumFeature" : "AnnotationDatumFeature", "AnnotationSurfaceFinish" : "AnnotationSurfaceFinish", "AnnotationDatumTarget" : "AnnotationDatumTarget", "AnnotationWeldSymbol" : "AnnotationWeldSymbol", "AnnotationBalloon" : "AnnotationBalloon", "AnnotationSpecialtyNote" : "AnnotationSpecialtyNote", "Table" : "Table", "CustomSymbol" : "CustomSymbol", "Centerline" : "Centerline", "Region" : "Region", "SecurityMarking" : "SecurityMarking", "CuttingPlaneSymbol" : "CuttingPlaneSymbol", "AnnotationEdgeConditionSymbol" : "AnnotationEdgeConditionSymbol"});

export default SPLM;